module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal",
    attrs: {
      "title": "编辑订单信息",
      "width": "1200"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData
    }
  }, [(_vm.isEditisReceive) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到帐方式：",
      "prop": "receiveType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.receiveType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "receiveType", _vm._n($$v))
      },
      expression: "formData.receiveType"
    }
  }, _vm._l((_vm.$constant.receiveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到帐金额：",
      "prop": "money"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.money),
      callback: function($$v) {
        _vm.$set(_vm.formData, "money", _vm._n($$v))
      },
      expression: "formData.money"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "到账时间：",
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.pData.time),
      callback: function($$v) {
        _vm.$set(_vm.pData, "time", _vm._n($$v))
      },
      expression: "pData.time"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注：",
      "prop": "remark"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isEditisReceive) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票时间：",
      "prop": "invoiceTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeInvoiceTime
    },
    model: {
      value: (_vm.pData.invoiceTime),
      callback: function($$v) {
        _vm.$set(_vm.pData, "invoiceTime", _vm._n($$v))
      },
      expression: "pData.invoiceTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票金额：",
      "prop": "invoiceMoney"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.invoiceMoney),
      callback: function($$v) {
        _vm.$set(_vm.formData, "invoiceMoney", _vm._n($$v))
      },
      expression: "formData.invoiceMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退票冲红：",
      "prop": "isRushRed"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.isRushRed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isRushRed", _vm._n($$v))
      },
      expression: "formData.isRushRed"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款金额：",
      "prop": "refundMoney"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.refundMoney),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refundMoney", _vm._n($$v))
      },
      expression: "formData.refundMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "退款时间：",
      "prop": "refundTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.changeRefundTime
    },
    model: {
      value: (_vm.pData.refundTime),
      callback: function($$v) {
        _vm.$set(_vm.pData, "refundTime", _vm._n($$v))
      },
      expression: "pData.refundTime"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472ab53d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/PerformanceModel.vue
// module id = 1776
// module chunks = 8